import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import FieldCombo from '../combos/FieldCombo';
import SchoolClassCombo from '../combos/SchoolClassCombo';
import { Checkbox } from 'primereact/checkbox';
import * as XLSX from "xlsx";
import { Col, Form, Row } from 'react-bootstrap';
import fileSaver from 'file-saver'
import ShowVideo from '../shared/ShowVideo';



export default function SchoolStudents(props) {
  const [redirectUrl, setRedirectUrl] = useState("");
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editFormVisible, setEditFormVisible] = useState(false);
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
  const [confirmResetStudentPassVisible, setConfirmResetStudentPassVisible] = useState(false);
  const [confirmResetParentPassVisible, setConfirmResetParentPassVisible] = useState(false);
  const [excelFormVisible, setExcelFormVisible] = useState(false);
  const [degreeNotExistInExcel, setDegreeNotExistInExcel] = useState(false);
  const [fieldNotExistInExcel, setFieldNotExistInExcel] = useState(false);
  const [excelStudents, setExcelStudents] = useState([]);
  const [fields, setFields] = useState([]);
  const file_Ref = useRef(null);


  const [currentItem, setCurrentItem] = useState(null);
  const [items, setItems] = useState([]);
  const [filterItems, setFilterItems] = useState([]);
  const LoadingRows = Array.from({ length: 5 });

  const [degree, setDegree] = useState(0);
  const [field, setField] = useState("");
  const [nationalId, setNationalId] = useState("");
  const [mobile, setMobile] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [parentLastname, setParentLastname] = useState("");
  const [parentFirstname, setParentFirstname] = useState("");
  const [parentMobile, setParentMobile] = useState("");
  const [parentNationalId, setParentNationalId] = useState("");
  const [searchDegree, setSearchDegree] = useState(null);
  const [searchField, setSearchField] = useState("");
  const [searchText, setSearchText] = useState("");
  const [searchSchoolClass, setSearchSchoolClass] = useState("");

  useEffect(() => {
    searchStudents();
  }, []);
  const searchStudents = function () {
    setLoading(true);
    var sDegree = -1;
    var sfiesldId = "";
    var sText = "";
    var sSchoolClassId = "";
    if ((searchDegree != null) && (searchDegree != "")) {
      sDegree = parseInt(searchDegree);
    }
    if (searchField != null) {
      if (searchField.id != null) {
        sfiesldId = searchField.id;
      }
    }
    if (searchText != null) {
      sText = searchText;
    }
    if (searchSchoolClass != null) {
      if (searchSchoolClass.id != null) {
        sSchoolClassId = searchSchoolClass.id;
      }
    }

    var params = { login: util.getTrustedUser(), lastIndex: 0, pageSize: 0, useParent: false, degree: sDegree, schoolClassId: sSchoolClassId, fieldId: sfiesldId, searchText: sText };
    var url = config.Server + `/school/school-student/list`;
    console.log("params is>", params);
    console.log("url is>", url);
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;
          console.log("response is>", response);

          setItems(response);
          setFilterItems(response);

          setLoading(false);
          setExcelFormVisible(false);
          setExcelStudents([]);
        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setSaving(false);
        }
      })
      .catch(error => {
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
        setSaving(false);
      });
  }
  const addNewItem = function () {
    setCurrentItem(null);
    setDegree();
    setNationalId("");
    setMobile("");
    setFirstname("");
    setLastname("");
    setParentLastname("");
    setParentFirstname("");
    setParentMobile("");
    setParentNationalId("");
    setField("");
    setEditFormVisible(true);
  }
  const showExcelForm = function () {
    setExcelStudents([]);
    setExcelFormVisible(true);
  }
  const closeExcelDialog = function () {
    setExcelFormVisible(false);
  }
  const onRowEditClick = function (row) {
    setCurrentItem(row);
    setDegree(row.degree);
    setNationalId(row.nationalId);
    setMobile(row.mobile);
    setFirstname(row.firstname);
    setLastname(row.lastname);
    setParentLastname(row.parentLastname);
    setParentFirstname(row.parentFirstname);
    setParentMobile(row.parentMobile);
    setParentNationalId(row.parentNationalId);
    setField(row.field);
    setEditFormVisible(true);
  }
  const onRowResetStudentPassClick = function (row) {
    setCurrentItem(row);
    setConfirmResetStudentPassVisible(true);
  }
  const resetStudentPassItem = function () {
    setDeleting(true);
    var id = currentItem.id;
    var nationalId = currentItem.nationalId;
    var params = { login: util.getTrustedUser(), nationalId: nationalId };
    console.log("reser param is>", params)
    var url = config.Server + `/user/school/user/reset-password`;
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;

          setErrorMessage("رمز دانش آموز با موفقیت به شماره موبایل دانش آموز تغیر یافت");
          setErorVisible(true);
          setCurrentItem(null);

          setDeleting(false);
          setConfirmResetStudentPassVisible(false);
        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setDeleting(false);
        }
      })
      .catch(error => {
        setDeleting(false);
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
      });
  }
  const onResetStudentPassConfirm_Accept = function () {
    resetStudentPassItem();
  }
  const onResetStudentPassConfirm_Reject = function () {
    if (deleting) return;
    setConfirmResetStudentPassVisible(false);
  }

  //--------------------------------------
  const onRowResetParentPassClick = function (row) {
    setCurrentItem(row);
    setConfirmResetParentPassVisible(true);
  }
  const resetParentPassItem = function () {
    setDeleting(true);
    var id = currentItem.id;
    var nationalId = currentItem.parentNationalId;
    var params = { login: util.getTrustedUser(), nationalId: nationalId };
    console.log("reser param is>", params)
    var url = config.Server + `/user/school/user/reset-password`;
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;

          setErrorMessage("رمز ولی دانش آموز با موفقیت به شماره موبایل ولی تغیر یافت");
          setErorVisible(true);
          setCurrentItem(null);

          setDeleting(false);
          setConfirmResetParentPassVisible(false);
        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setDeleting(false);
        }
      })
      .catch(error => {
        setDeleting(false);
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
      });
  }
  const onResetParentPassConfirm_Accept = function () {
    resetParentPassItem();
  }
  const onResetParentPassConfirm_Reject = function () {
    if (deleting) return;
    setConfirmResetParentPassVisible(false);
  }

  //--------------------------------------
  const onRowDeleteClick = function (row) {
    setCurrentItem(row);
    setConfirmDeleteVisible(true);
  }

  const closeEditDialog = function () {
    setEditFormVisible(false);
  }
  const deleteItem = function () {
    setDeleting(true);
    var id = currentItem.id;
    var params = { login: util.getTrustedUser(), userId: id };
    var url = config.Server + `/school/school-student/delete`;
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;
          var tmp = [...items];
          for (var i = 0; i < tmp.length; i++) {
            if (tmp[i].id === id) {
              tmp.splice(i, 1);
              break;
            }
          }
          setCurrentItem(null);
          setItems(tmp);
          setFilterItems(tmp);

          setDeleting(false);
          setConfirmDeleteVisible(false);
        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setDeleting(false);
        }
      })
      .catch(error => {
        setDeleting(false);
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
      });
  }
  const onDeleteConfirm_Accept = function () {
    deleteItem();
  }
  const onDeleteConfirm_Reject = function () {
    if (deleting) return;
    setConfirmDeleteVisible(false);
  }

  const checkDataEntry = function () {
    if (firstname.trim().length == 0) {
      setErrorMessage("نام دانش آموز را وارد کنید");
      setErorVisible(true);
      return false;
    }
    if (lastname.trim().length == 0) {
      setErrorMessage("خانوادگی دانش آموز را وارد کنید");
      setErorVisible(true);
      return false;
    }
    if (nationalId.trim().length == 0) {
      setErrorMessage("کد ملی را وارد کنید");
      setErorVisible(true);
      return false;
    }
    if (!util.IsValidNationalCode(nationalId)) {
      setErrorMessage("کد ملی دانش آموز نامعتبر است");
      setErorVisible(true);
      return false;
    }
    if (mobile.trim().length == 0) {
      setErrorMessage("شماره تلفن دانش آموز را وارد کنید");
      setErorVisible(true);
      return false;
    }
    if(parentNationalId != null){
      if(parentNationalId.length >= 1){
        if (parentFirstname.trim().length == 0) {
          setErrorMessage(" نام ولی را وارد کنید");
          setErorVisible(true);
          return false;
        }
        if (parentLastname.trim().length == 0) {
          setErrorMessage("نام خانوادگی ولی را وارد کنید");
          setErorVisible(true);
          return false;
        }
        if (parentNationalId.trim().length == 0) {
          setErrorMessage("کد ملی ولی را وارد کنید");
          setErorVisible(true);
          return false;
        }
        if (!util.IsValidNationalCode(parentNationalId)) {
          setErrorMessage("کد ملی ولی دانش آموز نامعتبر است");
          setErorVisible(true);
          return false;
        }
        if (parentMobile.trim().length == 0) {
          setErrorMessage("شماره تلفن ولی را وارد کنید");
          setErorVisible(true);
          return false;
        }
      }
    }

    if ((degree == "") || (degree == null)) {
      setErrorMessage("پایه تحصیلی را وارد کنید");
      setErorVisible(true);
      return false;
    }
    if (field == null || field.id == "" || !field.id) {
      setErrorMessage("رشته را انتخاب کنید");
      setErorVisible(true);
      return false;
    }
    return true;
  }
  const saveItem = function () {
    if (!checkDataEntry()) return;

    setSaving(true);
    var id = "";
    if (currentItem != null) {
      id = currentItem.id;
    }
    var parent = parent = { firstname: "", lastname: "", nationalId: "", mobile: "" };;
    if(parentNationalId != null){
      if(parentNationalId.length >= 10){
        parent = { firstname: parentFirstname, lastname: parentLastname, nationalId: parentNationalId, mobile: parentMobile };
      }
    }
    var params = { login: util.getTrustedUser(), id: id, degree: degree, firstname: firstname, mobile: mobile, fieldId: field.id, lastname: lastname, nationalId: nationalId, parent: parent };
    var url = config.Server + `/school/school-student/save`;
    console.log('param-->', params)
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        ;
        if (response.state === "ok") {
          response = response.data;
          setExcelFormVisible(false);
          setExcelStudents([]);
          searchStudents();

          setSaving(false);
          setEditFormVisible(false);

        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setSaving(false);
        }
      })
      .catch(error => {
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
        setSaving(false);
      });

  }
  const editDialogFooter = function () {
    return (
      <GeneralDialogFooter onOkClick={() => { saveItem() }} onCancelClick={() => { closeEditDialog() }} saving={saving} />
    )
  }
  const excelDialogFooter = function () {
    return (
      <GeneralDialogFooter onOkClick={() => { saveExcelItems() }} onCancelClick={() => { closeExcelDialog() }} saving={saving} />
    )
  }
  const saveExcelItems = function () {
    if (excelStudents.length == 0) {
      setErrorMessage("هیچ دانش آموزی جهت ثبت انتخاب نشده است");
      setErorVisible(true);
      return;
    }

    setSaving(true);
    var id = "";
    if (currentItem != null) {
      id = currentItem.id;
    }
    var params = { login: util.getTrustedUser(), students: excelStudents };
    var url = config.Server + `/school/school-student/list/save`;
    console.log('url-->', url)
    console.log('param-->', params)
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        ;
        if (response.state === "ok") {
          response = response.data;

          setSaving(false);
          setEditFormVisible(false);

          searchStudents();
        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setSaving(false);
        }
      })
      .catch(error => {
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
        setSaving(false);
      });
  }
  const onInputChange = function (e, name) {
    var val = '';
    val = (e.target && e.target.value) || '';
    if (name === "degree") setDegree(val);
    else if (name === "firstname") setFirstname(val);
    else if (name === "lastname") setLastname(val);
    else if (name === "nationalId") setNationalId(val);
    else if (name === "mobile") setMobile(val);
    else if (name === "parentFirstname") setParentFirstname(val);
    else if (name === "parentLastname") setParentLastname(val);
    else if (name === "parentMobile") setParentMobile(val);
    else if (name === "parentNationalId") setParentNationalId(val);
    else if (name === "searchText") setSearchText(val);
    else if (name === "searchDegree") setSearchDegree(val);
  }

  const onComboChange = function (name, value) {
    if (name === "field") {
      setField(value);
    }
    else if (name === "searchSchoolClass") {
      setSearchSchoolClass(value);
    }
    else if (name === "searchField") {
      setSearchField(value);
    }
    console.log("field-->", field);
    return
  }

  const setRowActions = function (row) {
    return (
      <Row className="justify-content-md-center" style={{}}>
        <Button icon="pi pi-pencil" rounded severity="success" style={{ width: "45px", margin: "0px 3px", float: "right" }} onClick={() => onRowEditClick(row)} title="ویرایش" />
        <Button icon="pi pi-key" rounded severity="secondary" style={{ width: "45px", margin: "0px 3px", float: "right" }} onClick={() => onRowResetStudentPassClick(row)} title="ریست کلمه عبور دانش آموز" />
        <Button icon="pi pi-key" rounded severity="primary" style={{ width: "45px", margin: "0px 3px", float: "right" }} onClick={() => onRowResetParentPassClick(row)} title="ریست کلمه عبور ولی" />
        <Button icon="pi pi-trash" rounded severity="danger" style={{ width: "45px", margin: "0px 3px", float: "right" }} onClick={() => onRowDeleteClick(row)} title="حذف" />
      </Row>
    );
  }
  const onCheckboxChange = (e, name) => {
    if (name === "degree") setDegreeNotExistInExcel(e.checked);
    if (name === "field") setFieldNotExistInExcel(e.checked);
  }
  const btnSelectFileClick = function () {
    if (degreeNotExistInExcel) {
      var dg = -1;
      if ((degree != null) && (degree != "")) dg = parseInt(degree);
      if (dg == -1) {
        setErrorMessage("پایه تحصیلی را تنظیم نمائید");
        return;
      }
    }
    if (fieldNotExistInExcel) {
      if (field == null || field.id == "" || !field.id) {
        setErrorMessage("رشته تحصیلی را انتخاب کنید");
        setErorVisible(true);
        return;
      }
    }
    file_Ref.current.click();
  }
  const afterFileSelected = async function (e) {
    const file = e.target.files[0];
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    const jsonData = XLSX.utils.sheet_to_json(worksheet, {
      header: 1,
      defval: "",
    });


    if (jsonData.length <= 1) {
      setErrorMessage("فایل خالی است");
      setErorVisible(true);
      return;
    }
    var rows = [];
    var valid_cols = 8;
    if (!degreeNotExistInExcel) valid_cols++;
    if (!fieldNotExistInExcel) valid_cols++;
    for (var i = 1; i < jsonData.length; i++) {
      var r = i + 1;
      var row = jsonData[i];
      if (row.length > 0) {
        var hasData = false;
        for (var j = 0; j < row.length; j++) {
          if (row[j] != null) {
            if (row[j] != "") {
              hasData = true;
              break;
            }
          }
        }
        if (!hasData) continue;

        if (row.length < valid_cols) {
          var msg = "در ردیف شماره " + r + " داده ها ناقض است";
          setErrorMessage(msg);
          setErorVisible(true);
          return;
        }
        var ind = 0;
        var mc = util.toEnglishDigits(String(row[ind])).trim(); if (mc.length == 8) mc = "00" + mc; if (mc.length == 9) mc = "0" + mc;
        if (mc.length < 10) {
          var msg = "در ردیف شماره " + r + " خطا مشاهده می شود" + "\n" + "کد ملی دانش آموز باید 10 رقمی است" + ", " + mc;
          setErrorMessage(msg);
          setErorVisible(true);
          return;
        }
        if (!util.IsIntNumber(mc)) {
          var msg = "در ردیف شماره " + r + " خطا مشاهده می شود" + "\n" + "کد ملی دانش آموز باید عددی است" + ", " + mc;
          setErrorMessage(msg);
          setErorVisible(true);
          return;
        }
        if (!util.IsValidNationalCode(mc)) {
          var msg = "در ردیف شماره " + r + " خطا مشاهده می شود" + "\n" + "کد ملی دانش آموز نامعتبر است" + ", " + mc;
          setErrorMessage(msg);
          setErorVisible(true);
          return;
        }
        ind++;
        var fn = row[ind];
        if (fn.length < 2) {
          var msg = "در ردیف شماره " + r + " خطا مشاهده می شود" + "\n" + "نام دانش آموز نامعتبر است";
          setErrorMessage(msg);
          setErorVisible(true);
          return;
        }
        ind++;
        var ln = row[ind];
        if (ln.length < 2) {
          var msg = "در ردیف شماره " + r + " خطا مشاهده می شود" + "\n" + "نام خانوادگی دانش آموز نامعتبر است";
          setErrorMessage(msg);
          setErorVisible(true);
          return;
        }
        ind++;
        var mob = util.toEnglishDigits(String(row[ind])); if (mob.length == 10) mob = "0" + mob;
        if (mob.length != 11) {
          console.log("mobile is not valid 1>", mob);
          var msg = "در ردیف شماره " + r + " خطا مشاهده می شود" + "\n" + "موبایل دانش آموز نامعتبر است";
          setErrorMessage(msg);
          setErorVisible(true);
          return;
        }
        if (!util.IsMobileValid(mob.toString())) {
          console.log("mobile is not valid 2>", mob);
          var msg = "در ردیف شماره " + r + " موبایل دانش آموز نامعتبر است";
          setErrorMessage(msg);
          setErorVisible(true);
          return;
        }

        ind++
        var pmc = util.toEnglishDigits(String(row[ind])).trim(); if (pmc.length == 8) pmc = "00" + pmc; if (pmc.length == 9) pmc = "0" + pmc;
        if (pmc.length < 10) {
          var msg = "در ردیف شماره " + r + " خطا مشاهده می شود" + "\n " + "کد ملی ولی دانش آموز باید 10 رقمی است" + ", " + pmc;
          setErrorMessage(msg);
          setErorVisible(true);
          return;
        }
        if (!util.IsIntNumber(pmc)) {
          var msg = "در ردیف شماره " + r + " خطا مشاهده می شود" + "\n " + "کد ملی ولی دانش آموز باید عددی است" + ", " + pmc;
          setErrorMessage(msg);
          setErorVisible(true);
          return;
        }
        if (!util.IsValidNationalCode(pmc)) {
          console.log(mc)
          console.log(pmc)
          var msg = "در ردیف شماره " + r + " خطا مشاهده می شود" + "\n " + "کد ملی ولی دانش آموز نامعتبر است" + ", " + pmc;
          setErrorMessage(msg);
          setErorVisible(true);
          return;
        }
        ind++;
        var pfn = row[ind];
        if (pfn.length < 2) {
          var msg = "در ردیف شماره " + r + " خطا مشاهده می شود" + "\n" + "نام ولی دانش آموز نامعتبر است" + ", " + pfn;
          setErrorMessage(msg);
          setErorVisible(true);
          return;
        }
        ind++;
        var pln = row[ind];
        if (pln.length < 2) {
          var msg = "در ردیف شماره " + r + " خطا مشاهده می شود" + "\n" + "نام خانوادگی ولی دانش آموز نامعتبر است";
          setErrorMessage(msg);
          setErorVisible(true);
          return;
        }
        ind++;
        var pmobile = util.toEnglishDigits(String(row[ind])); if (pmobile.length == 10) pmobile = "0" + pmobile;
        if (pmobile.length != 11) {
          var msg = "در ردیف شماره " + r + " خطا مشاهده می شود" + "\n" + "موبایل ولی دانش آموز نامعتبر است";
          setErrorMessage(msg);
          setErorVisible(true);
          return;
        }
        if (!util.IsMobileValid(pmobile.toString())) {
          var msg = "در ردیف شماره " + r + " موبایل ولی دانش آموز نامعتبر است";
          setErrorMessage(msg);
          setErorVisible(true);
          return;
        }

        ind++;
        var deg = -1;
        if (degreeNotExistInExcel) {
          deg = degree;
        }
        else {
          deg = util.toEnglishDigits(row[ind]);
          if (!util.IsIntNumber(deg)) {
            var msg = "در ردیف شماره " + r + " خطا مشاهده می شود" + "\n" + "پایه تحصیلی نامعتبر است";
            setErrorMessage(msg);
            setErorVisible(true);
            return;
          }
          if (deg > 12) {
            var msg = "در ردیف شماره " + r + " خطا مشاهده می شود" + "\n" + "پایه تحصیلی نامعتبر است";
            setErrorMessage(msg);
            setErorVisible(true);
            return;
          }
        }
        ind++;
        var fiId = "";
        if (fieldNotExistInExcel) {
          fiId = field.id;
        }
        else {
          var fiCode = util.toEnglishDigits(row[ind]);
          if (!util.IsIntNumber(fiCode)) {
            var msg = "در ردیف شماره " + r + " خطا مشاهده می شود" + "\n" + "کد رشته تحصیلی نامعتبر است";
            setErrorMessage(msg);
            setErorVisible(true);
            return;
          }
          for (var k = 0; k < fields.length; k++) {
            if (fields[k].code == fiCode) {
              fiId = fields[k].id;
              break;
            }
          }
          if (fiId == "") {
            var msg = "در ردیف شماره " + r + " خطا مشاهده می شود" + "\n" + "کد رشته تحصیلی نامعتبر است";
            setErrorMessage(msg);
            setErorVisible(true);
            return;
          }
        }

        rows.push({
          degree: parseInt(deg),
          firstname: fn,
          mobile: mob,
          fieldId: fiId,
          lastname: ln,
          nationalId: mc.toString(),
          parent: { firstname: pfn, lastname: pln, nationalId: pmc.toString(), mobile: pmobile }
        });
      }
    }
    if (rows.length === 0) {
      setErrorMessage("فایل خالی است");
      setErorVisible(true);
      return;
    }
    setExcelStudents(rows)
  }
  return (
    <>
    <ShowVideo videoId="school_save_students" top={65} md={6} /> 
      <div className="page-caption">لیست دانش آموزان</div>
      <div className="" style={{}}>
        <div style={{ backgroundColor: '#e9edffff', padding: '5px', borderRadius: '5px', width: "100%", display: 'flow-root' }}>
          <Row>
            <Col md={3} style={{ height: "75px", paddingTop: "30px" }}>
              <FloatLabel>
                <InputText value={searchText} onChange={(e) => { onInputChange(e, "searchText") }} id="searchText" keyfilter="" maxLength={50} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center", padding: '10px' }} />
                <label htmlFor="username">جستجو</label>
              </FloatLabel>
            </Col>
            <Col md={3}>
              <FieldCombo returnFullItem={true} value={searchField} onChange={(val) => onComboChange('searchField', val)} />
            </Col>
            <Col md={3} style={{ height: "75px", paddingTop: "30px" }}>
              <FloatLabel>
                <InputText value={searchDegree} onChange={(e) => { onInputChange(e, "searchDegree") }} id="searchDegree" keyfilter="" maxLength={50} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center", padding: '10px' }} />
                <label htmlFor="username">پایه</label>
              </FloatLabel>
            </Col>
            <Col md={3}>
              <SchoolClassCombo returnFullItem={true} value={searchSchoolClass} onChange={(val) => onComboChange('searchSchoolClass', val)} />
            </Col>
          </Row>
          <Row>
            <Col>
              <div style={{ float: 'right', margin: '10px', display: 'block', direction: "ltr", textAlign: "right" }}>
                <Button label="جستجو" icon="pi pi-search" onClick={() => searchStudents()} severity="primary" iconPos="right" />
              </div>

            </Col>
          </Row>
        </div>
      </div>
      <div className="card" style={{ overflow: "scroll" }}>
        {
          loading ?
            <DataTable value={LoadingRows} className="p-datatable-striped">
              <Column field="id" header="کد" style={{ width: '20%' }} body={<Skeleton />}></Column>
              <Column field="title" header="عنوان" style={{ width: '80%' }} body={<Skeleton />}></Column>
            </DataTable>
            :
            <>
              <div className='col-12' style={{ overflowX: "scroll" }}>
                <Row style={{}}>
                  <Col md={2}>
                    <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign: "right", margin: "10px" }}>
                      <Button label="افزودن به لیست" icon="pi pi-plus" onClick={() => addNewItem()} severity="secondary" iconPos="right" />
                    </div>
                  </Col>
                  <Col md={2}>
                    <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign: "right", margin: "10px" }}>
                      <Button label="افزودن از اکسل" icon="pi pi-file-excel" onClick={() => showExcelForm()} severity="secondary" iconPos="right" />
                    </div>
                  </Col>
                </Row>
                <DataTable value={filterItems} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{ minWidth: '50rem' }} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
                  paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                  currentPageReportTemplate="{first} تا {last} از {totalRecords}"
                  dataKey="id" selection={currentItem} onSelectionChange={(e) => { setCurrentItem(e.value) }}>
                  <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column>
                  <Column header="#" headerStyle={{ width: '3rem' }} body={(data, options) => options.rowIndex + 1} className="list-cell-text-align"></Column>
                  {config.ShowListId ? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column> : <></>}
                  <Column field="nationalId" header={"کد ملی"} sortable className="list-cell-text-align"></Column>
                  <Column field="firstname" header={"نام"} sortable className="list-cell-text-align"></Column>
                  <Column field="lastname" header={"نام خانوادگی"} sortable className="list-cell-text-align"></Column>
                  <Column field="parentFirstname" header={"ولی"} sortable className="list-cell-text-align"></Column>
                  <Column field="degree" header={"پایه"} sortable className="list-cell-text-align"></Column>
                  <Column field="field.title" body={(row) => row.field.title} header={"رشته"} sortable className="list-cell-text-align"></Column>
                  <Column body={(row) => setRowActions(row)} exportable={false} style={{ width: '200px' }}></Column>
                </DataTable>
              </div>
            </>
        }
      </div>
      {
        editFormVisible ?
          <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
            header="ثبت دانش آموز" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => closeEditDialog()}>
            <Row>
              <Col md={6}>
                <div style={{ textAlign: "center", backgroundColor: "#2233bb", color: "#fff", marginTop: "10px", padding: "5px 0px 5px 0px", borderRadius: "5px" }}>
                  مشخصات دانش آموز
                </div>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr><td>&nbsp;</td></tr>
                    <tr>
                      <td style={{ padding: "1px" }}>
                        <FloatLabel>
                          <InputText value={firstname} onChange={(e) => { onInputChange(e, "firstname") }} id="firstname" keyfilter="" maxLength={25} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                          <label htmlFor="username">نام</label>
                        </FloatLabel>
                      </td>
                    </tr>
                    <tr><td>&nbsp;</td></tr>
                    <tr>
                      <td style={{ padding: "1px" }}>
                        <FloatLabel>
                          <InputText value={lastname} onChange={(e) => { onInputChange(e, "lastname") }} id="lastname" keyfilter="" maxLength={25} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                          <label htmlFor="username">نام خانوادگی</label>
                        </FloatLabel>
                      </td>
                    </tr>
                    <tr><td>&nbsp;</td></tr>
                    <tr>
                      <td style={{ padding: "1px" }}>
                        <FloatLabel>
                          <InputText value={nationalId} onChange={(e) => { onInputChange(e, "nationalId") }} id="nationalId" keyfilter="int" maxLength={12} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                          <label htmlFor="username">کد ملی</label>
                        </FloatLabel>
                      </td>
                    </tr>
                    <tr><td>&nbsp;</td></tr>
                    <tr>
                      <td style={{ padding: "1px" }}>
                        <FloatLabel>
                          <InputText value={mobile} onChange={(e) => { onInputChange(e, "mobile") }} id="mobile" keyfilter="int" maxLength={11} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                          <label htmlFor="username">موبایل</label>
                        </FloatLabel>
                      </td>
                    </tr>
                    <tr><td>&nbsp;</td></tr>
                    <tr>
                      <td style={{ padding: "1px" }}>
                        <FloatLabel>
                          <InputText value={degree} onChange={(e) => { onInputChange(e, "degree") }} id="degree" keyfilter="int" maxLength={2} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                          <label htmlFor="username">پایه</label>
                        </FloatLabel>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <FieldCombo returnFullItem={true} value={field} onChange={(val) => onComboChange('field', val)} />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col md={6}>
                <div style={{ textAlign: "center", backgroundColor: "#2233bb", color: "#fff", marginTop: "10px", padding: "5px 0px 5px 0px", borderRadius: "5px" }}>
                  مشخصات ولی دانش آموز
                </div>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr><td>&nbsp;</td></tr>
                    <tr>
                      <td style={{ padding: "1px" }}>
                        <FloatLabel>
                          <InputText value={parentFirstname} onChange={(e) => { onInputChange(e, "parentFirstname") }} id="parentFirstname" keyfilter="" maxLength={25} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                          <label htmlFor="username">نام ولی</label>
                        </FloatLabel>
                      </td>
                    </tr>
                    <tr><td>&nbsp;</td></tr>
                    <tr>
                      <td style={{ padding: "1px" }}>
                        <FloatLabel>
                          <InputText value={parentLastname} onChange={(e) => { onInputChange(e, "parentLastname") }} id="parentLastname" keyfilter="" maxLength={25} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                          <label htmlFor="username">نام خانوادگی ولی</label>
                        </FloatLabel>
                      </td>
                    </tr>
                    <tr><td>&nbsp;</td></tr>
                    <tr>
                      <td style={{ padding: "1px" }}>
                        <FloatLabel>
                          <InputText value={parentNationalId} onChange={(e) => { onInputChange(e, "parentNationalId") }} id="parentNationalId" keyfilter="int" maxLength={12} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                          <label htmlFor="username">کد ملی ولی</label>
                        </FloatLabel>
                      </td>
                    </tr>
                    <tr><td>&nbsp;</td></tr>
                    <tr>
                      <td style={{ padding: "1px" }}>
                        <FloatLabel>
                          <InputText value={parentMobile} onChange={(e) => { onInputChange(e, "parentMobile") }} id="parentMobile" keyfilter="int" maxLength={11} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                          <label htmlFor="username">موبایل ولی</label>
                        </FloatLabel>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
            </Row>

          </Dialog>
          :
          <></>
      }
      {
        excelFormVisible ?
          <Dialog visible={true} style={{ width: '95%', minHeight: "500px" }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
            header="ثبت لیست دانش آموزان از اکسل" modal className="p-fluid" footer={() => excelDialogFooter()} onHide={() => closeExcelDialog()}>
            <Row>
              <Col md={6}>
                <div style={{ backgroundColor: "royalblue", color: "#ffffff", textAlign: 'center', borderRadius: "3px", padding: "10px", width: "calc(100% - 10px)", marginTop: "15px" }}>تنظیمات داده ها</div>
                <div className="flex align-items-center" style={{ marginTop: "10px" }}>
                  <Checkbox inputId="chk1" name="pizza" value="Cheese" onChange={(e) => { onCheckboxChange(e, "degree") }} checked={degreeNotExistInExcel} />
                  <label htmlFor="chk1" className="ml-2"> &nbsp;پایه تحصیلی در فایل اکسل تنظیم نشده است</label>
                </div>
                <div className="flex align-items-center" style={{ marginTop: "25px", maxWidth: "200px", marginRight: "30px" }}>
                  <FloatLabel>
                    <InputText disabled={!degreeNotExistInExcel} value={degree} onChange={(e) => { onInputChange(e, "degree") }} id="degree" keyfilter="int" maxLength={2} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                    <label htmlFor="username">پایه تحصیلی</label>
                  </FloatLabel>
                </div>
                <div className="flex align-items-center" style={{ marginTop: "10px" }}>
                  <Checkbox inputId="chk2" name="pizza" value="Cheese" onChange={(e) => { onCheckboxChange(e, "field") }} checked={fieldNotExistInExcel} />
                  <label htmlFor="chk2" className="ml-2"> &nbsp;رشته تحصیلی در فایل اکسل تنظیم نشده است</label>
                </div>
                <div className="flex align-items-center" style={{ marginTop: "25px", maxWidth: "300px", marginRight: "30px" }}>
                  <FloatLabel>
                    <FieldCombo disabled={!fieldNotExistInExcel} returnFullItem={true} value={field} onChange={(val) => onComboChange('field', val)} afterLoad={(items) => { console.log("fields is>>>", items); setFields(items) }} />
                  </FloatLabel>
                </div>
                <div className="flex align-items-center" style={{ marginTop: "50px", maxWidth: "300px", marginRight: "30px", direction: "ltr" }}>
                  <Button label="انتخاب فایل اکسل" icon="pi pi-file-excel" onClick={btnSelectFileClick} disabled={saving} iconPos="right" severity="" />
                </div>
                <div className="flex align-items-center" style={{ marginTop: "25px", maxWidth: "300px", marginRight: "30px" }}>
                  <br />
                  <label style={{ fontSize: "14pt" }}>تعداد دانش آموز انتخاب شده : {excelStudents.length}</label>
                  <br />
                </div>
              </Col>
              <Col md={6}>
                <div style={{ backgroundColor: "royalblue", color: "#ffffff", textAlign: 'center', borderRadius: "3px", padding: "10px", width: "calc(100% - 10px)", marginTop: "15px" }}>مشخصات ضروری در فایل اکسل</div>
                <div style={{ width: "100%", overflowY: "scroll", maxWidth: "600px" }}>
                  <div className="flex align-items-center" style={{ marginTop: "10px", maxWidth: "250px", marginRight: "0px", direction: "ltr" }}>
                    <Button label="دانلود نمونه فایل اکسل" icon="pi pi-file-excel" onClick={() => { fileSaver.saveAs("https://Classico7.ir/asset/studentlist_sample.xlsx") }} disabled={saving} iconPos="right" severity="primary" />
                  </div>
                  <br />
                  <a href='https://Classico7.ir/asset/studentlist_sample.xlsx' download="studentlist_sample.xlsx" target="_blank">لینک دوم دانلود نمونه فایل اکسل</a>
                  <br />
                  <img src={require("../lib/images/StudentListExcelSample.jpg")} style={{ width: "100%" }} />
                  <br />
                  <img src={require("../lib/images/valid_degreeis.jpg")} style={{ width: "70%" }} />
                  <br />
                  <label style={{ fontSize: "14pt" }}>رشته های قابل ثبت</label>
                  <table style={{ borderCollapse: "collapse" }}>
                    <tr>
                      <td style={{ border: "1px solid #b0b0b0" }}>کد رشته</td>
                      <td style={{ border: "1px solid #b0b0b0" }}>نام رشته</td>
                    </tr>
                    {
                      fields.map((p) => {
                        return (
                          <tr>
                            <td style={{ border: "1px solid #b0b0b0" }}>{p.code}</td>
                            <td style={{ border: "1px solid #b0b0b0" }}>{p.title}</td>
                          </tr>
                        )
                      })
                    }
                  </table>
                </div>
              </Col>
            </Row>

          </Dialog>
          :
          <></>
      }
      <input accept=".xlsx" type="file" ref={file_Ref} onInput={(e) => afterFileSelected(e)} style={{ display: "none" }} />
      <ShowError visible={errorVisible} message={errorMessage} closeError={() => { setErorVisible(false) }} />
      <ShowConfirm visible={confirmDeleteVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteConfirm_Accept} onReject={onDeleteConfirm_Reject} loading={deleting} />
      <ShowConfirm visible={confirmResetStudentPassVisible} message="آیا از ریست کلمه عبور دانش آموز مطمئن هستید؟" caption="اطمینان از ریست کلمه عبور" onAccept={onResetStudentPassConfirm_Accept} onReject={onResetStudentPassConfirm_Reject} loading={deleting} />
      <ShowConfirm visible={confirmResetParentPassVisible} message="آیا از ریست کلمه عبور ولی دانش آموز مطمئن هستید؟" caption="اطمینان از ریست کلمه عبور" onAccept={onResetParentPassConfirm_Accept} onReject={onResetParentPassConfirm_Reject} loading={deleting} />
    </>
  );
}
